<template>
  <section class="hr-section hr-rn" aria-label="Отзывы и новости">
    <div class="hr-container hr-rn__grid">
      <div class="hr-rn__reviews">
        <h2 class="hr-section-title hr-rn__title">
          <HrIcon v-if="review.iconImage" :image="review.iconImage" />
          <span>{{ review.title }}</span>
        </h2>
        <div class="hr-rn__review-wrap">
          <article class="hr-review-card">
            <div class="hr-review-card__head">
              <span class="hr-review-card__avatar" aria-hidden="true">{{ initials }}</span>
              <div>
                <strong class="hr-review-card__name">{{ review.name }}</strong>
                <time class="hr-review-card__date">{{ review.date }}</time>
              </div>
            </div>
            <p class="hr-review-card__text">{{ review.text }}</p>
            <div class="hr-review-card__rating">
              <span class="hr-review-card__stars" aria-label="Оценка 5 из 5">
                <HrIcon v-for="n in 5" :key="n" name="star" />
              </span>
              <strong>{{ review.ratingLabel }}</strong>
            </div>
          </article>
          <div class="hr-rn__side-photo">
            <img :src="review.sideImage" :alt="review.sideImageAlt" />
          </div>
        </div>
        <router-link class="hr-btn hr-btn--outline hr-btn--wide" :to="review.allTo">
          {{ review.allLabel }}
        </router-link>
      </div>

      <div class="hr-rn__news">
        <div class="hr-rn__news-head">
          <h2 class="hr-section-title">{{ news.title }}</h2>
        </div>

        <div
          v-if="latestNews"
          class="hr-rn__news-wrap"
          :class="{ 'hr-rn__news-wrap--no-photo': !latestNews.imageUrl }"
        >
          <div v-if="latestNews.imageUrl" class="hr-rn__side-photo" aria-hidden="true">
            <img :src="latestNews.imageUrl" alt="" />
          </div>
          <router-link
            class="hr-news-card hr-news-card--text-only"
            :to="{ name: 'NewsItem', params: { id: latestNews.id } }"
          >
            <time class="hr-news-card__date">{{ formatDate(latestNews.dateTime) }}</time>
            <h3 class="hr-news-card__title">{{ latestNews.title }}</h3>
            <p class="hr-news-card__desc">{{ latestNews.description }}</p>
          </router-link>
        </div>

        <router-link
          class="hr-btn hr-btn--outline hr-btn--wide hr-rn__news-cta"
          :to="news.allTo"
        >
          {{ news.allLabel }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import HrIcon from './HrIcon.vue'
import NewsAPi from '@/api/news.js'

export default {
  name: 'HrReviewsNews',
  components: { HrIcon },
  props: {
    review: { type: Object, required: true },
    news: { type: Object, required: true },
  },
  data() {
    return {
      latestNews: null,
    }
  },
  computed: {
    initials() {
      const parts = String(this.review.name || '').split(/\s+/)
      return parts.map((p) => p.charAt(0)).join('').slice(0, 2)
    },
  },
  mounted() {
    this.loadLatestNews()
  },
  methods: {
    formatDate(value) {
      if (!value) return ''
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) return String(value)
      return d.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    },
    async loadLatestNews() {
      try {
        const response = await NewsAPi.getNews()
        if (
          response &&
          response.data &&
          response.data.status === 'SUCCESS' &&
          Array.isArray(response.data.result)
        ) {
          const items = response.data.result
          const fallback = items && items.length ? items[0] : null

          const latest = items.reduce((best, item) => {
            if (!item || !item.dateTime) return best
            const t = new Date(item.dateTime).getTime()
            if (Number.isNaN(t)) return best

            if (!best || !best.dateTime) return item
            const bt = new Date(best.dateTime).getTime()
            if (Number.isNaN(bt)) return item

            return t > bt ? item : best
          }, fallback)

          this.latestNews = latest || null
        }
      } catch (e) {
        // Silent fallback: остаёмся без новости, но страница не падает
        console.warn('HrReviewsNews: не удалось загрузить новости', e)
      }
    },
  },
}
</script>
